import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=c04f0a0e&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c04f0a0e')) {
      api.createRecord('c04f0a0e', component.options)
    } else {
      api.reload('c04f0a0e', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=c04f0a0e&", function () {
      api.rerender('c04f0a0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2uLypWyNWd67a/JS/imageCarousel.vue"
export default component.exports